<template>
  <div>
    <w-datepicker class="form-group" :model="schema.resumeDate" />

    <w-textarea v-if="schema.comment" :model="schema.comment" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz daty końca deecyzji
// @group ActionData
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
